import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=32221c10"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports